import React, { useEffect, useState, useContext } from 'react'
import DataContext from "../data/DataContext";
import SettingService from '../Services/Setting.service';
import Swal from 'sweetalert2'

function Setting() {
  const dataConf = useContext(DataContext)
 const settingService = new SettingService()
 const [system,setSystem] = useState({})

 const sysStatus = ()=>{
    settingService.get_system_status().then((result) => {
      if (result.success){
        // console.log(result.data)
        setSystem(result.data)
      }else{
        Swal.fire({
          title: result.message,
          text:'',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#890000',
        })
      }
    });
 }

 useEffect(()=>{
  sysStatus()
 },[])

 useEffect(()=>{
  // console.log(system)
 },[system])

 const con_maintenance = (e)=>{
   e.preventDefault()
   const time_service = e.target.time_service.value
   const payload = {p_con_service:system.con_service,p_time_service:time_service}
   // console.log(payload)
   Swal.fire({
    title: 'ยืนยัน',
    text: 'คุณต้องการตั้งค่าการเปิด/ปิดเพื่อปรับปรุงระบบหรือไม่',
    icon: 'warning',
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonText: 'ตกลง',
    confirmButtonColor: 'green',
    cancelButtonText: 'ยกเลิก',
  }).then(async (result) => {
    if (result.isConfirmed) {
      dataConf.blockUI()
      settingService.system_maintenance(payload).then((result) => {
        dataConf.blockUI()
        if (result.success){
          // console.log(result.data)
          Swal.fire({
            title: result.message,
            text:'',
            icon: 'success',
            confirmButtonText: 'ตกลง',
            confirmButtonColor: 'green',
          })
        }else{
          Swal.fire({
            title: result.message,
            text:'',
            icon: 'warning',
            confirmButtonText: 'ตกลง',
            confirmButtonColor: '#890000',
          })
        }
      });
    }
  })

  
}

  return (
    <div className="container pt-3">
        <h4>ควบคุมระบบ</h4>
        <hr/>
        <div className="card col-sm-4">
          <div className="card-body">
            <form onSubmit={con_maintenance}>
              <div className="mb-1">
                <label className="form-label">ปิดปรับปรุงระบบ</label>
              </div>
              <div className="mb-2">
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="system_status" id="system_status" onClick={()=>{setSystem({...system,con_service:1})}} defaultChecked={system.con_service} />
                  <label className="form-check-label" htmlFor="system_on">เปิดระบบ</label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="system_status" id="system_status" onClick={()=>{setSystem({...system,con_service:0})}} defaultChecked={!system.con_service}/>
                  <label className="form-check-label" htmlFor="system_off">ปิดระบบ</label>
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-6">
                  <input type="text" className="form-control form-control-sm" name="time_service" id="time_service" defaultValue={system.time_service}/>
                </div>
                <div className="mb-3 col-2">
                  <button type="submit" className="btn btn-control btn-sm btn-warning">บันทึก</button>
                </div>
              </div>
            </form>
          </div>
        </div>
    </div>
  )
}

export default Setting